import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ButtonLink, Container } from '../../design';
import { AnalyticsEvent, ctaEvent } from '../../utils/analytics';
import { MKT } from './links';
// The closing call to action on every marketing page. On an audience's page it asks that
// audience in (its sign-up link preselects them); elsewhere it offers both ways in.
const COPY = {
    dealer: {
        title: 'Run your import business from one place.',
        sub: 'Pick a plan and the setup guide walks you through your exporter, mailbox, costs and first hunt. If you’d rather talk first, book a call.'
    },
    individual: {
        title: 'Bring your own car home, one step at a time.',
        sub: 'Your sign-up covers your first car. The setup guide handles the rest with you, from the exporter account and the car you want to customs and shipping.'
    },
    both: {
        title: 'From the auction in Japan to your door.',
        sub: 'For dealerships, and for people importing their own car. Start as either one and the setup guide picks it up from there.'
    }
};
export function CtaBand({ audience, title, sub }) {
    const copy = COPY[audience ?? 'both'];
    return /*#__PURE__*/ _jsx("section", {
        children: /*#__PURE__*/ _jsx(Container, {
            className: "mk-cta",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "mk-cta__panel rhd-band-amber",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        "aria-hidden": "true",
                        className: "mk-cta__ghost",
                        children: "右"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mk-cta__copy",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "mk-cta__eyebrow",
                                children: "始 · Get started"
                            }),
                            /*#__PURE__*/ _jsx("h2", {
                                className: "mk-cta__title",
                                children: title ?? copy.title
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "mk-cta__sub",
                                children: sub ?? copy.sub
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mk-cta__actions",
                        children: [
                            audience === 'dealer' && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(ButtonLink, {
                                        href: MKT.signupFor('dealer'),
                                        variant: "paper",
                                        ...ctaEvent(AnalyticsEvent.ctaSignup, 'band', 'dealer'),
                                        children: "Get started"
                                    }),
                                    /*#__PURE__*/ _jsx(ButtonLink, {
                                        href: MKT.bookCall,
                                        variant: "onColor",
                                        ...ctaEvent(AnalyticsEvent.ctaBookCall, 'band', 'dealer'),
                                        children: "Book a 20-minute call"
                                    })
                                ]
                            }),
                            audience === 'individual' && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(ButtonLink, {
                                        href: MKT.signupFor('individual'),
                                        variant: "paper",
                                        ...ctaEvent(AnalyticsEvent.ctaSignup, 'band', 'individual'),
                                        children: "Start importing my own"
                                    }),
                                    /*#__PURE__*/ _jsx(ButtonLink, {
                                        href: MKT.pricingFor('individual'),
                                        variant: "onColor",
                                        children: "See what it costs"
                                    })
                                ]
                            }),
                            !audience && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(ButtonLink, {
                                        href: MKT.signupFor('dealer'),
                                        variant: "paper",
                                        ...ctaEvent(AnalyticsEvent.ctaSignup, 'band', 'dealer'),
                                        children: "I run a dealership"
                                    }),
                                    /*#__PURE__*/ _jsx(ButtonLink, {
                                        href: MKT.signupFor('individual'),
                                        variant: "paper",
                                        ...ctaEvent(AnalyticsEvent.ctaSignup, 'band', 'individual'),
                                        children: "I’m importing my own"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}
